@if (error !== '' || success !== '') {
  <mat-card class="mb-m p-m">
    @if (success !== '' ) {
      <p>
        {{success}}
      </p>
    }
    @if (error !== '' ) {
      <p>
        {{error}}
      </p>
    }
  </mat-card>

}

@if (container) {
  <div class="d-flex jcsb">
    <h2>{{folder ? folder : container}}</h2>
    <div class="w-30 d-flex jce">
      <div  class="d-flex aic">
        <button matIconButton extended (click)="addFile()" color="primary">
          <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">upload_file</mat-icon>
        </button> Upload File
      </div>
      <div  class="d-flex aic">
        <button matIconButton extended (click)="addFolder()" color="accent">
          <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">create_new_folder</mat-icon>
        </button> Create Folder
      </div>

      <div  class="d-flex aic">
        <button matIconButton extended (click)="deleteCurrentFolder()">
          <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">folder_delete</mat-icon>
        </button> Delete Folder
      </div>
    </div>
  </div>
}
@if (dataSource.data.length > 0) {
  <div>
    <mat-table #files [dataSource]="dataSource">
      <ng-container matColumnDef="filename">
        <mat-header-cell *matHeaderCellDef> Dateiname</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef> Typ</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element.kind === 'prefix' ? ('folder' | translate): findType(element)}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="modified_by">
        <mat-header-cell *matHeaderCellDef> Modified By</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getUser(element) }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Datum</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ (element.kind === 'prefix' ? getDate(element.Properties["Creation-Time"]) : getDate(
          element.properties["createdOn"])) | date: 'dd.MM.yyyy' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
       <mat-header-cell *matHeaderCellDef class="text-center"> Aktionen</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button matIconButton color="primary"
            (click)="element.kind === 'prefix' ? deleteFolder(element): remove(element)" alt="Delete">
            <mat-icon fontSet="material-symbols-outlined">{{element.kind === 'prefix' ? 'delete_sweep' : 'delete'}}</mat-icon>
          </button>
          @if (element.kind === 'blob') {
            <button matIconButton color="accent" cdkCopyToClipboard [cdkCopyToClipboard]="copyLink(element)" (cdkCopyToClipboardCopied)="copied(element)" alt="Copy link to clipboard">
              <mat-icon fontSet="material-symbols-outlined">content_copy</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
}
